import { createReducer, on } from '@ngrx/store';
import { setSelectedDemand } from './demand.actions';
import { initialDemandState } from './demand.state';

export const demandReducer = createReducer(
  initialDemandState,
  on(setSelectedDemand, (state, { demand }) => ({
    ...state,
    demand,
  }))
);
